export const WAIT_BEFORE_RETRY_MS = 1_000
export const MAX_WAIT_BEFORE_RETRY_MS = 10_000
export const MAX_RETRY_ATTEMPTS = 120
